// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__21uFL","requiredAsterisk":"Info_requiredAsterisk__O3y3G"};